import { createContext, useContext } from 'react';

/**
 * Context for calendar zoom state.
 * Provides scaleFactor and browser detection for components that need to adjust
 * coordinates based on CSS zoom (e.g., tooltips).
 */
const ZoomContext = createContext({
  scaleFactor: 1,
  isSafari: false
});

/**
 * Hook to access zoom context.
 * @returns {Object} Zoom context
 * @returns {number} returns.scaleFactor - Current zoom scale factor (0.25 to 5.0)
 * @returns {boolean} returns.isSafari - Whether the browser is Safari
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useZoom() {
  const context = useContext(ZoomContext);
  if (!context) {
    // If used outside ZoomProvider, return defaults (no zoom adjustment)
    return { scaleFactor: 1, isSafari: false };
  }
  return context;
}

export default ZoomContext;
